// extracted by mini-css-extract-plugin
var _1 = "OkYdq";
var _2 = "sixcq";
export { _1 as "group", _2 as "segmented" }
